import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useAppStore } from '@/store/app'
import { useAuthStore } from '@/store/auth'
import { isPlatformStaff } from '@/lib/moderationApi'
import { ModerationSection } from './ModerationSection'

export function ModerationWorkspace() {
  const open = useAppStore(s => s.moderationOpen)
  const close = useAppStore(s => s.closeModeration)
  const staff = useAuthStore(s => isPlatformStaff(s.user?.flags ?? 0))
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!open || !staff) return
    const previous = document.activeElement as HTMLElement | null
    const root = ref.current
    const app = document.querySelector<HTMLElement>('[data-view]')
    if (app) app.inert = true
    root?.querySelector<HTMLButtonElement>('button')?.focus()
    const key = (e: KeyboardEvent) => {
      if (e.defaultPrevented || document.querySelector('[role="dialog"][aria-modal="true"]')) return
      if (e.key === 'Escape') { e.preventDefault(); close() }
      if (e.key !== 'Tab' || !root?.contains(document.activeElement)) return
      const items = Array.from(root.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]')).filter(el => el.getClientRects().length)
      const first = items[0], last = items.at(-1)
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus() }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus() }
    }
    document.addEventListener('keydown', key)
    return () => { document.removeEventListener('keydown', key); if (app) app.inert = false; if (previous?.isConnected) previous.focus() }
  }, [open, staff, close])
  return open && staff ? createPortal(<div ref={ref}><ModerationSection onClose={close} /></div>, document.fullscreenElement ?? document.body) : null
}
